import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useT } from '../lib/i18n'
import { OverlayContext } from '../ui/OverlayContext'
import { PhoneFrame } from '../ui/PhoneFrame'

/**
 * A user who mistyped a URL needs a way home, not a note about routing
 * structure. A review caught the first version showing the developer-facing
 * explanation that lives on `Pushed`. SUAP-0104.
 */
export function NotFound() {
  const [overlayRoot, setOverlayRoot] = useState<HTMLElement | null>(null)
  const navigate = useNavigate()
  const { t } = useT()

  return (
    <PhoneFrame>
      {/* Every route that is its own column carries its own overlay root, so the
          rule is "a column has one" rather than "some columns have one" — an
          inconsistency here is what makes the rule hard to remember later. */}
      <OverlayContext.Provider value={overlayRoot}>
        <main className="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 p-6 text-center">
          <p className="text-5xl" aria-hidden>
            🍽️
          </p>
          <h1 className="text-xl font-semibold text-ink">{t('notFound.title')}</h1>
          <p className="text-ink-soft">{t('notFound.body')}</p>
          <button
            type="button"
            onClick={() => navigate('/today', { replace: true })}
            className="min-h-11 rounded-chip bg-ink px-5 font-medium text-ground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
          >
            {t('action.home')}
          </button>
        </main>

        <div ref={setOverlayRoot} id="overlay-root" className="absolute inset-0 empty:hidden" />
      </OverlayContext.Provider>
    </PhoneFrame>
  )
}
